import { BadgeColor, SkeletonText } from '@billy/design-system'
import { ReactElement, ReactNode } from 'react'

import { BadgeLabel } from '../BadgeLabel'
import * as Styled from './styles'

interface TableBadgeLabelProps {
  amount?: number
  children?: ReactNode
  color?: BadgeColor
  isLoading?: boolean
}

export const TableBadgeLabel = ({ amount, children, color, isLoading }: TableBadgeLabelProps): ReactElement => {
  return (
    <Styled.TableBadgeLabelWrapper>
      {isLoading ? (
        <SkeletonText variant="h4" width={78} />
      ) : (
        <BadgeLabel badgeAmount={amount || 0} badgeColor={color} label={children} />
      )}
    </Styled.TableBadgeLabelWrapper>
  )
}
